import * as redux from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

// list of actions that won't be logged by redux logger
const actionsToNotLog = [
    'REDUX_STORAGE_SAVE',
];

export const getDevMiddlewares = () => {
    return [
        // Add other middleware on this line...

        // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
        reduxImmutableStateInvariant(),

        createLogger({
            predicate: (getState, action) => {
                return !actionsToNotLog.includes(action.type);
            },
        }),
    ];
};

export const createStore = (rootReducer, initialState, middlewares) => {
    return redux.createStore(rootReducer, initialState,
        composeWithDevTools(redux.applyMiddleware(...middlewares)));
}

// FIXME: this is broken since Sprint 1.
/*if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('../reducers', () => {
    const nextReducer = require('../reducers').default; // eslint-disable-line global-require
    store.replaceReducer(nextReducer);
  });
}*/
